import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

const countLimit = 5;

export function ToastMessageTitle({ title }) {
  return <b className="preferred-suppliers-toast-message__title">{title}</b>;
}

ToastMessageTitle.propTypes = {
  title: PropTypes.string,
};

export function ToastMessageContentSuppliers({ suppliers, added, bold }) {
  const count = suppliers.length;
  const sliced = suppliers.slice(0, countLimit);

  return count ? (
    <div className="preferred-suppliers-toast-message__suppliers">
      {sliced.map(({ label }) => label).join(', ')} {sliced.length < suppliers.length ? 'and more ' : ''}
      {count > 1 ? 'have' : 'has'} been {added ? <>{bold ? <b>added</b> : 'added'} to</> : <>{bold ? <b>deleted</b> : 'deleted'} from</>}{' '}
      your supplier preferences.
    </div>
  ) : null;
}

ToastMessageContentSuppliers.defaultProps = {
  suppliers: [],
};

ToastMessageContentSuppliers.propTypes = {
  suppliers: PropTypes.array,
  added: PropTypes.bool,
  bold: PropTypes.bool,
};

export const getTitleAndContentForToastMessage = ({ addedSuppliers, deletedSuppliers }) => {
  if (!isEmpty(addedSuppliers) > 0 && isEmpty(deletedSuppliers)) {
    return {
      title: <ToastMessageTitle title="New supplier added to your preferences" />,
      content: <ToastMessageContentSuppliers suppliers={addedSuppliers} added />,
    };
  }

  if (isEmpty(addedSuppliers) && !isEmpty(deletedSuppliers)) {
    return {
      title: <ToastMessageTitle title="Supplier deleted from your preferences" />,
      content: <ToastMessageContentSuppliers suppliers={deletedSuppliers} />,
    };
  }

  return {
    title: <ToastMessageTitle title="A change was made to your supplier preferences" />,
    content: (
      <>
        <ToastMessageContentSuppliers suppliers={addedSuppliers} added bold />{' '}
        <ToastMessageContentSuppliers suppliers={deletedSuppliers} bold />
      </>
    ),
  };
};
